import React from "react"
import { Stack, Text } from "@chakra-ui/react"
import Modal from "components/dialogs/Modal"
import LanguageTemplateReference from "components/settings/LanguageTemplateReference"
import type { DioboxEvent } from "sharedTypes"

type Props = {
  isOpen: boolean
  onClose: () => void
  event: DioboxEvent
}

const KIOSK_FIELDS = [
  { key: "kioskScanQrCode" },
  { key: "kioskRegister" },
  { key: "kioskCheckedIn" },
  { key: "kioskInvalidQrCode" },
  { key: "kioskDuplicateQrCode" },
  { key: "kioskPrintingBadge" },
  { key: "kioskPrintingError" },
  { key: "kioskAccessRestricted" },
] as const

const KioskOnScreenTextModal = ({ isOpen, onClose, event }: Props) => (
  <Modal
    show={isOpen}
    hide={onClose}
    title="On-Screen Text"
    size="lg"
  >
    <LanguageTemplateReference
      eventId={event.id}
      field={[...KIOSK_FIELDS]}
      description={(resolvedName) => (
        <Stack spacing={2}>
          <Text>
            Guest-facing buttons and messages in Kiosk Mode use the event&apos;s
            language template, currently set to{" "}
            <Text as="span" fontWeight="semibold">{resolvedName}</Text>.
          </Text>
          <Text>
            Change or customize the template in{" "}
            <Text as="span" fontWeight="semibold">
              Event Settings → Language Templates
            </Text>.
          </Text>
        </Stack>
      )}
    />
  </Modal>
)

export default KioskOnScreenTextModal
